@if (autoJoining) {
  <div
    class="ap-join-splash"
    [class.ap-join-splash--leaving]="splashLeaving"
    data-test="splash"
  >
    <div class="ap-join-splash__glow" aria-hidden="true"></div>
    <div class="ap-join-splash__content">
      <app-branding-logos
        class="ap-join-splash__logo"
        [deviceUuid]="splashDeviceUuid"
        [forceDark]="true"
        [logoOnly]="true"
      />
      <h1 class="ap-join-splash__title">Connecting to live captions</h1>
      <div class="ap-join-splash__wave" aria-hidden="true">
        <span></span><span></span><span></span><span></span><span></span>
      </div>
      <p class="ap-join-splash__hint">Hold on a moment…</p>
    </div>
    <app-branding-logos class="ap-join-splash__footer" [creditOnly]="true" [forceDark]="true" />
  </div>
} @else {
  <div class="ap-join-page">
    <main class="ap-join-card" [class.ap-join-card--ended]="sessionEndedByHost">
      @if (!sessionEndedByHost) {
        <img
          class="ap-join-card__logo"
          src="assets/logo-white.svg"
          alt="Speaksee"
          width="180"
          height="36"
        />
      }

      @if (sessionEndedByHost) {
        <div class="ap-join-card__ended" data-test="session-ended">
          <mat-icon class="ap-join-card__ended-icon" aria-hidden="true">favorite</mat-icon>
          <h1 class="ap-join-card__title">Thanks for joining</h1>
          <p class="ap-join-card__lead">
            The host has ended this session. We hope you enjoyed following along.
          </p>
          <app-branding-logos
            class="ap-join-card__branding"
            [deviceUuid]="endedDeviceUuid"
            [showPoweredBy]="true"
          />
        </div>
      } @else if (qrFailed) {
        <div class="ap-join-card__trouble" data-test="qr-failed">
          <mat-icon class="ap-join-card__trouble-icon" aria-hidden="true">link_off</mat-icon>
          <h1 class="ap-join-card__title">This code didn't work</h1>
          <p class="ap-join-card__lead">
            The code is either invalid or has expired. Ask the host for a fresh code.
          </p>
          <button class="ap-join-card__submit" type="button" (click)="retryQrJoin()">
            Try again
          </button>
          <button class="ap-join-card__link" type="button" (click)="enterCodeManually()">
            Or enter the code manually
          </button>
        </div>
      } @else if (scheduledStartsAt) {
        <div class="ap-join-card__scheduled" data-test="scheduled">
          <mat-icon class="ap-join-card__scheduled-icon" aria-hidden="true">schedule</mat-icon>
          <h1 class="ap-join-card__title">Session starts soon</h1>
          <p class="ap-join-card__lead">The host has scheduled this session for</p>
          <p class="ap-join-card__time">
            {{ scheduledStartsAt | date: 'EEEE, MMMM d \'at\' h:mm a' }}
          </p>
          <p class="ap-join-card__hint">We'll connect you as soon as it goes live.</p>
        </div>
      } @else if (inLobby) {
        <div class="ap-join-card__scheduled" data-test="lobby">
          <mat-icon class="ap-join-card__scheduled-icon" aria-hidden="true">hourglass_top</mat-icon>
          <h1 class="ap-join-card__title">This session hasn't started yet</h1>
          <p class="ap-join-card__lead">
            Hang tight — we'll connect you the moment the host starts it.
          </p>
          <p class="ap-join-card__hint">Keep this page open.</p>
        </div>
      } @else {
        <h1 class="ap-join-card__title">Join a session</h1>
        <p class="ap-join-card__lead">Enter the 6-digit code to join the live captions.</p>

        <app-join-code-input class="ap-join-card__otp" (codeChange)="onCodeChange($event)" />

        <button
          class="ap-join-card__submit"
          type="button"
          (click)="submit()"
          [disabled]="submitting || code.length !== 6"
        >
          {{ submitting ? 'Joining…' : 'Join session' }}
        </button>

        @if (errorMessage) {
          <p class="ap-join-card__error" role="alert">{{ errorMessage }}</p>
        }

        <p class="ap-join-card__support">Powered by Speaksee · Live captioning</p>
      }
    </main>
  </div>
}
